<template>
  <div v-if="dynamicContent.isModalOpen">
    <ul
      class="nav nav-tabs"
    >
      <li
        v-for="tab in tabs"
        :key="tab.id"
        class="nav-item"
      >
        <a
          href="#"
          class="nav-link"
          :class="{'router-link-active': tab.id === selectedTab}"
          @click="(e) => onTabSelected(e, tab.id)"
        >
          {{ tab.title }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div v-show="selectedTab === 1">
        <CustomLinks v-if="!tabs[0].pristine" />
      </div>
      <div v-show="selectedTab === 2">
        <GlobalLinks v-if="!tabs[1].pristine" />
      </div>
      <div v-show="selectedTab === 3">
        <AddOns v-if="!tabs[2].pristine" />
      </div>
      <div v-show="selectedTab === 4">
        <PersonalizationTags v-if="!tabs[3].pristine" />
      </div>
      <div v-show="selectedTab === 5">
        <AllLinksAndImages v-if="!tabs[4].pristine" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddOns from './AddOns'
import PersonalizationTags from './PersonalizationTags'
import CustomLinks from './CustomLinks'
import GlobalLinks from './GlobalLinks'
import AllLinksAndImages from './AllLinksAndImages'

export default {
  components: {
    AddOns,
    PersonalizationTags,
    CustomLinks,
    GlobalLinks,
    AllLinksAndImages
  },
  data () {
    return {
      tabs: [
        {
          id: 1,
          title: 'Custom Links',
          template: 'templateCustomLinks',
          pristine: false
        },
        {
          id: 2,
          title: 'Global Links',
          template: 'templateGlobalLinks',
          pristine: true
        },
        {
          id: 3,
          title: 'Add-On Snippet',
          template: 'templateAddOns',
          pristine: true
        },
        {
          id: 4,
          title: 'Personalization Tags',
          template: 'templatePersonalizationTags',
          pristine: true
        },
        {
          id: 5,
          title: 'All Links and Images',
          template: 'templateAllLinksAndImages',
          pristine: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      dynamicContent: 'getDynamicContent',
      selectedTab: 'getDynamicContentTabSelected'
    }),
    currentTabContent () {
      const currentTab = this.tabs.find(tab => tab.id === this.selectedTab)
      if (currentTab) {
        return this[currentTab.content]
      }
      return ''
    }
  },
  watch: {
    selectedTab (newVal, oldVal) {
      if (newVal !== oldVal) {
        const newCurrentTab = this.tabs.find(tab => tab.id === newVal)
        if (newCurrentTab && newCurrentTab.pristine) {
          newCurrentTab.pristine = false
        }
      }
    }
  },
  methods: {
    onTabSelected (e, id) {
      e.preventDefault()
      this.$store.commit('SET_DYNAMIC_CONTENT_SELECTED_TAB', id)
    }
  }
}
</script>

<style>
  @import "../../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
  @import "../../../node_modules/@syncfusion/ej2-vue-buttons/styles/bootstrap4.css";
  @import "../../../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap4.css";
  @import "../../../node_modules/@syncfusion/ej2-vue-navigations/styles/bootstrap4.css";
</style>
